import _styled from "@emotion/styled-base";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { colors } from '@airwallex/global';
import { jsx as ___EmotionJSX } from "@emotion/core";

var HelpTextStyle = _styled("p", {
  target: "eipsv4z0",
  label: "HelpTextStyle"
})(function (_ref) {
  var isErrored = _ref.isErrored;
  return {
    fontSize: 14,
    margin: '4px 0 0',
    color: isErrored ? colors.red : colors.greyOnGreyText
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL2hlbHBUZXh0L2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJc0IiLCJmaWxlIjoiLi4vLi4vaGVscFRleHQvaW5kZXgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNvbG9ycyB9IGZyb20gJ0BhaXJ3YWxsZXgvZ2xvYmFsJztcblxuY29uc3QgSGVscFRleHRTdHlsZSA9IHN0eWxlZC5wPHsgaXNFcnJvcmVkPzogYm9vbGVhbjsgaXNXYXJuaW5nPzogYm9vbGVhbiB9PigoeyBpc0Vycm9yZWQgfSkgPT4gKHtcbiAgZm9udFNpemU6IDE0LFxuICBtYXJnaW46ICc0cHggMCAwJyxcbiAgY29sb3I6IGlzRXJyb3JlZCA/IGNvbG9ycy5yZWQgOiBjb2xvcnMuZ3JleU9uR3JleVRleHQsXG59KSk7XG5cbmNvbnN0IEhlbHBUZXh0ID0gKHtcbiAgdGV4dCxcbiAgaXNFcnJvcmVkLFxuICBpc1dhcm5pbmcsXG4gIC4uLmV0Y1xufToge1xuICB0ZXh0Pzogc3RyaW5nO1xuICBpc0Vycm9yZWQ/OiBib29sZWFuO1xuICBpc1dhcm5pbmc/OiBib29sZWFuO1xufSkgPT4ge1xuICBpZiAoIXRleHQpIHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfVxuXG4gIHJldHVybiAoXG4gICAgPEhlbHBUZXh0U3R5bGUgaXNFcnJvcmVkPXtpc0Vycm9yZWR9IGlzV2FybmluZz17aXNXYXJuaW5nfSB7Li4uZXRjfT5cbiAgICAgIHt0ZXh0fVxuICAgIDwvSGVscFRleHRTdHlsZT5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEhlbHBUZXh0O1xuIl19 */");

var HelpText = function HelpText(_ref2) {
  var text = _ref2.text,
      isErrored = _ref2.isErrored,
      isWarning = _ref2.isWarning,
      etc = _objectWithoutProperties(_ref2, ["text", "isErrored", "isWarning"]);

  if (!text) {
    return null;
  }

  return ___EmotionJSX(HelpTextStyle, _extends({
    isErrored: isErrored,
    isWarning: isWarning
  }, etc), text);
};

export default HelpText;